import './polyfills';
import './i18n';
import './assets/global.css';
import './assets/tailwind.css';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';

import { ModalsProvider } from '@mantine/modals';
import * as Sentry from '@sentry/react';
import mixpanel from 'mixpanel-browser';
import { Suspense } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initEnv, initInstance, beforeSend, ThemeProvider, MIXPANEL_TOKEN } from '@mygpt/app';
import { AppRoutes } from '@/routes';
import VConsole from 'vconsole';
import { Notifications } from '@mantine/notifications';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

initEnv(import.meta.env.VITE_STAGE);
initInstance({
  baseUrl: import.meta.env.VITE_API_BASE_URL,
  baseHost: import.meta.env.VITE_BASE_HOST || '',
});

// remove end slash from basename
const basename =
  // @ts-ignore
  import.meta.env.VITE_PUBLIC_PATH === '/'
    ? '/'
    : // @ts-ignore
      import.meta.env.VITE_PUBLIC_PATH.replace(/\/$/, '');

if (['pre', 'production', 'staging', 'onprem-main'].includes(import.meta.env.VITE_STAGE)) {
  Sentry.init({
    //@ts-ignore
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_STAGE,
    integrations: [Sentry.replayIntegration()],
    beforeSend,
    tracesSampleRate: 1.0,
    attachStacktrace: true,
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

let ContentRoutes = () => <AppRoutes />;
mixpanel.init(MIXPANEL_TOKEN, { debug: true, ignore_dnt: true });
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.has('debug')) {
  new VConsole();
}

root.render(
  <BrowserRouter basename={basename}>
    <ThemeProvider>
      <Suspense
        fallback={
          <div className="w-full h-screen flex items-center justify-center text-[70px] font-black tracking-wider text-gray-200 animate-pulse">
            GBase
          </div>
        }
      >
        <ModalsProvider>
          <Notifications position="top-center" limit={3} />
          <ContentRoutes />
        </ModalsProvider>
      </Suspense>
    </ThemeProvider>
  </BrowserRouter>
);
